import { loadApiSpecList } from "./LoadApiSpecList";
import { loadEntityPropertyMap } from "./LoadEntityPropertyMap";

export function loadMetadata(): void {
	loadEntityPropertyMap();
	loadApiSpecList();
}
